/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import {
    Channels,
    ChannelsApi,
    ChannelsGetRequest,
    Configuration,
    ConfigurationParameters,
} from 'client-code/channels-service';

import { APPLICATION_FEATURE_AREA } from '../../config';
import { CommonHeaders } from '../CommonHeaders';
import { Constants } from '../constants';
import { IChannelServiceRepository } from '../interfaces';
import { Log } from '../logging';
import { ChannelsServiceV1Contract } from '../servicecontracts';
import { TServicesParams } from '../types';
import { UniqueIdentifier } from '../utils';

export class ChannelsServiceRepositoryImpl
    implements IChannelServiceRepository<ChannelsServiceV1Contract>
{
    private readonly TAG: string = 'ChannelsServiceRepositoryImpl';

    private readonly mParams: TServicesParams;

    public constructor(params: TServicesParams) {
        this.mParams = params;
    }

    /**
     * get channels from server
     * @returns Channels
     */
    public async getChannelsFromServer(
        isFavorite: boolean = false,
        isReceived: boolean = false,
    ): Promise<Channels> {
        try {
            const commonHeaders = new CommonHeaders(APPLICATION_FEATURE_AREA.GUIDE).headers;

            const configurationParameters: ConfigurationParameters = {
                apiKey: this.mParams.accessToken,
                basePath: this.mParams.basePath,
                baseOptions: {
                    timeout: Constants.SERVICE_CONNECTION_TIMEOUT,
                    headers: commonHeaders,
                },
            };
            const requestParameters: ChannelsGetRequest = {
                applicationName: commonHeaders.ApplicationName,
                bodyId: this.mParams.bodyId,
                originRequestId: UniqueIdentifier.generateOriginRequestId(),
                isFavorite,
                isReceived,
                whiny: this.mParams.whiny || 'false',
            };
            const configuration = new Configuration(configurationParameters);
            const channelsService = new ChannelsApi(configuration);
            const serviceResponse = await channelsService.channelsGet(requestParameters);

            return serviceResponse.data;
        } catch (error) {
            Log.e(this.TAG, 'getChannels() - failed to fetch channels data', error);
            throw error;
        }
    }
}
